import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getPartDetailsApi } from "../Api/api";

const PartsContext = createContext();

export const useParts = () => useContext(PartsContext);

export const PartsProvider = ({ children }) => {
  const [partsList, setPartsList] = useState([]);
  const [loading, setLoading] = useState(true);

  const refreshParts = useCallback(async () => {
    setLoading(true);
    try {
      // Get company short code from localStorage
      const userData = localStorage.getItem("userData");
      const comShortCode = userData ? JSON.parse(userData).ComShortCode : "";
      
      console.log("PartsContext - Refreshing parts for ComShortCode:", comShortCode);
      
      const data = await getPartDetailsApi(comShortCode);
      console.log("PartsContext - API Response:", data);
      
      if (data.status === "success" && data.data) {
        // Handle new API response format
        if (Array.isArray(data.data[0])) {
          // New format: data.data[0] is the array of parts
          console.log("PartsContext - Using new format, parts:", data.data[0]);
          setPartsList(data.data[0] || []);
        } else {
          // Original format
          console.log("PartsContext - Using original format, parts:", data.data);
          setPartsList(data.data || []);
        }
      }
    } catch (error) {
      console.error("Error refreshing parts:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshParts();
  }, [refreshParts]);

  return (
    <PartsContext.Provider value={{ partsList, loading, refreshParts }}>
      {children}
    </PartsContext.Provider>
  );
};

export default PartsContext;
